import { c as _c } from "react/compiler-runtime";
import React from "react";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
interface InfoButtonProps {
  readonly loading?: boolean | undefined;
  readonly disabled?: boolean | undefined;
  readonly onClicked?: (() => void) | undefined;
  readonly children: React.ReactNode;
  readonly padding?: string | undefined;
  readonly title?: string | undefined;
  readonly variant?: "primary" | "info" | "muted" | undefined;
}

/**
 * Info-styled button for informational states like "coming soon"
 */
export default function InfoButton(t0) {
  const $ = _c(10);
  const {
    loading: t1,
    disabled: t2,
    onClicked,
    children,
    padding: t3,
    title,
    variant: t4
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const disabled = t2 === undefined ? false : t2;
  const padding = t3 === undefined ? "tw-px-2.5 tw-py-2" : t3;
  const variant = t4 === undefined ? "info" : t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      primary: "tw-bg-green-600/20 tw-text-green-400 tw-border tw-border-solid tw-border-green-700 hover:tw-bg-green-600/30",
      info: "tw-bg-blue-600/20 tw-text-blue-400 tw-border tw-border-solid tw-border-blue-700 hover:tw-bg-blue-600/30",
      muted: "tw-bg-iron-800 tw-text-iron-400 tw-border tw-border-solid tw-border-iron-700 tw-cursor-not-allowed"
    };
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  const variantClasses = t5;
  const baseClasses = `tw-flex tw-w-full tw-gap-x-1.5 tw-items-center tw-justify-center tw-rounded-lg ${padding} tw-text-sm tw-font-semibold tw-transition tw-duration-200 tw-ease-out`;
  const disabledClasses = disabled || loading ? "tw-opacity-50" : "";
  const t6 = disabled || loading;
  const t7 = `${baseClasses} ${variantClasses[variant]} ${disabledClasses}`;
  let t8;
  if ($[1] !== loading) {
    t8 = loading && <CircleLoader />;
    $[1] = loading;
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  let t9;
  if ($[3] !== children || $[4] !== onClicked || $[5] !== t6 || $[6] !== t7 || $[7] !== t8 || $[8] !== title) {
    t9 = <button onClick={onClicked} disabled={t6} type="button" title={title} className={t7}>{t8}{children}</button>;
    $[3] = children;
    $[4] = onClicked;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
    $[8] = title;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}